import React from 'react';
import PropTypes from 'prop-types';
import '../../index.module.scss';
import styles from './date-picker.module.scss';
import { Icon } from '../Icon';
import ReactDatePicker from 'react-date-picker';
import { c, getDateFormatForRegion } from '../../utils';

export const DatePicker = ({ className, minDate, maxDate, region, value, onChange, ...props }) => {
  const handleDateChange = (dateValue) => {
    const jsonDate = dateValue ? dateValue.toJSON() : null;
    onChange(jsonDate);
  };

  return (
    <div
      className={c(styles.reactDatePicker, className)}
      {...props}
    >
      <ReactDatePicker
        calendarIcon={<Icon name='annual_pa' />}
        clearIcon={null}
        format={getDateFormatForRegion(region)}
        minDate={minDate ? new Date(minDate) : null}
        minDetail='month'
        maxDate={maxDate ? new Date(maxDate) : null}
        maxDetail='month'
        value={value ? new Date(value) : null}
        onChange={handleDateChange}
      />
    </div>
  );
};

DatePicker.propTypes = {
  className: PropTypes.string,
  minDate: PropTypes.string,
  maxDate: PropTypes.string,
  region: PropTypes.string,
  value: PropTypes.string,
  onChange: PropTypes.func
};

DatePicker.defaultProps = {
  region: 'domestic'
};
